import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import SLMOwnerLinkList from "containers/slm/shared/SLMOwnerLinkList";

export default function SLMOwnerPartyPanel({
  title,
  state,
  onChange,
  onBlur,
  primaryRole,
  secondaryRole,
  extraFields = [],
  isAuthenticated,
  updateTableState,
  saveRecord,
  deleteRecord,
  sale_id = null,
  lease_id = null,
  user,
  state_code,
  validateRelatedRecord,
  getOwners,
  getContacts,
  getOwnerLinks,
  updateVendorFields,
  minimalPagination,
}) {
  const readOnlyForRole = (role) => state.ownerLinks.filter((f) => f.type === role.linkType).length > 0;

  return (
    <Card className="mb-2">
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <Form.Group as={Row} controlId={primaryRole.field}>
          <Form.Label className="text-right" column sm={4} md={4} lg={2}>
            {primaryRole.label}
          </Form.Label>
          <Col>
            <Form.Control readOnly={readOnlyForRole(primaryRole)} onChange={onChange} onBlur={onBlur} value={state[primaryRole.field] ?? ""} as="input" type="text" />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId={secondaryRole.field}>
          <Form.Label className="text-right" column sm={4} md={4} lg={2}>
            {secondaryRole.label}
          </Form.Label>
          <Col>
            <Form.Control readOnly={readOnlyForRole(secondaryRole)} onChange={onChange} onBlur={onBlur} value={state[secondaryRole.field] ?? ""} as="input" type="text" />
          </Col>
        </Form.Group>

        {extraFields.map(({ field, label }) => (
          <Form.Group as={Row} controlId={field} key={field}>
            <Form.Label className="text-right" column sm={4} md={4} lg={2}>
              {label}
            </Form.Label>
            <Col>
              <Form.Control onChange={onChange} onBlur={onBlur} value={state[field] ?? ""} as="input" type="text" />
            </Col>
          </Form.Group>
        ))}

        <Row>
          <Col>
            <SLMOwnerLinkList
              isAuthenticated={isAuthenticated}
              controlType="table2"
              data={state.ownerLinks}
              updateTableState={updateTableState}
              saveRecord={saveRecord}
              deleteRecord={deleteRecord}
              sale_id={sale_id}
              lease_id={lease_id}
              user={user}
              state_code={state_code}
              validateRelatedRecord={validateRelatedRecord}
              getOwners={getOwners}
              getContacts={getContacts}
              getOwnerLinks={getOwnerLinks}
              updateVendorFields={updateVendorFields}
              minimalPagination={minimalPagination}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
